import shadows from '../foundation/shadows';

const baseStylePopper = {
  zIndex: 999,
  width: 'auto',
  minW: 'auto',
  maxW: '1440px',
  borderRadius: '30px',
  boxShadow: shadows.hover
};

const Popover = {
  parts: ['popper', 'content', 'closeButton'],
  baseStyle: {
    content: {
      zIndex: 9999,
      minWidth: 'auto',
      width: 'auto',
      border: 'none',
      boxShadow: shadows.hover,
      _focus: { outline: 'none', boxShadow: 'none' }
    },
    popper: baseStylePopper,
    borderRadius: '30px',
    closeButton: { borderRadius: '100px' }
  },
  variants: {
    responsive: {
      popper: {
        ...baseStylePopper,
        maxWidth: 'unset',
        width: 'unset'
      }
    },
    expand: {
      popper: {
        zIndex: 999,
        maxWidth: '100%',
        width: '100%',
        border: '0px',
        borderRadius: '10px',
        boxShadow: 'none'
      },
      content: {
        _focus: { boxShadow: shadows.hover },
        border: 'none',
        boxShadow: shadows.hover,
        margin: 'auto'
      }
    }
  }
};

export default Popover;
